import { IReturnProductHotelOffer } from '@ve/pages/hotel/types';

export default function (products: IReturnProductHotelOffer[]): boolean {
    const hotelOffersProducts = products;
    return !!hotelOffersProducts.find((hotelOffer) => !!hotelOffer?.cancellationPolicy?.freeCancellationDateBefore);
}